import { stringify } from "qs";

class FETIASEntity {
    constructor(json, schema) {
        this.json = json;
        this.schema = schema;
    }

    hasChange(previous, displayName, columnName, skipEmptyNewRows = false) {
        try {
            let information = this.schema.find(x => x.displayName == displayName);
            if (information != null && previous != null) {
                switch (information.type) {
                    case 14:
                    case 15:
                        if (columnName != null) {
                            let currentRows = this.field(displayName);
                            let previousRows = previous.field(displayName);
                            // A per-row column only "changes" when one of its row values changes; a pure
                            // row-count change (rows added/removed) does not, on its own, alter a per-row
                            // formula's input. skipEmptyNewRows (native forms) therefore skips the
                            // row-count short-circuit and judges new rows by their actual value below.
                            if(!skipEmptyNewRows && currentRows != null && previousRows != null
                                && currentRows.length != previousRows.length) {
                                return true;
                            }

                            let change = currentRows.some(row => {
                                //if not found, changed
                                let previousRow = previousRows.find(x => x.field('id') == row.field('id'));
                                if (previousRow != null) {
                                    return row.hasChange(previousRow, columnName);
                                }

                                // A brand-new row counts as a change only if it actually carries a value
                                // for this column (compare against a blank row of the same schema); an
                                // empty new row leaves the per-row formula's input untouched.
                                if (skipEmptyNewRows) {
                                    return row.hasChange(new FETIASEntity({}, row.schema), columnName);
                                }
                                return true;
                            });
                            return change;
                        }
                        return JSON.stringify(this.field(displayName)) != JSON.stringify(previous.field(displayName))
                }

                if (information.type == 7 || information.type == 20) {
                    const isDiff = this.fieldId(displayName) != previous.fieldId(displayName);

                    if (isDiff) {
                        return true;
                    }
                }

                // SS04792 (client-side twin): Link, Location, Users and Locuses have no case of
                // their own in field(), so they hand back the stored json value as-is -- an object
                // or an array. "!=" on two objects is REFERENCE equality, and two snapshots of the
                // same saved data are always different instances, so those fields reported a change
                // on a form nobody had touched. Compare their contents instead, the same way the
                // Table/List branch above does.
                const current = this.field(displayName);
                const prior = previous.field(displayName);

                if (current !== null && prior !== null
                    && typeof current === 'object' && typeof prior === 'object') {
                    return JSON.stringify(current) != JSON.stringify(prior);
                }

                return current != prior;
            }
        }
        catch (ex) {
            console.log(ex);
        }

        return true;
    }

    fieldId(displayName) {
        let information = this.schema.find(x => x.displayName == displayName);

        if (information != null) {
            return this.json[information.fieldName + 'Id'];
        }
    }

    field(displayName) {
        if (this.json == null) {
            console.log(json)
        }


        if (displayName == 'id')
            return this.json['id'];

        let information = this.schema.find(x => x.displayName == displayName);
        if (information != null) {
            switch (information.type) {
                //table & list
                case 14:
                case 15:
                    if (this.json[information.fieldName] == null)
                        return [];
                    return this.json[information.fieldName].map(x => new FETIASEntity(x, information.fields))

                //yes / no
                case 1:
                    if (this.json[information.fieldName] == null)
                        return false;
                    return this.json[information.fieldName];

                case 3:
                case 4:
                    if (this.json[information.fieldName] == null)
                        return 0.0;
                    return parseFloat(this.json[information.fieldName] || 0);
                case 2:
                    if (this.json[information.fieldName] == null)
                        return 0;
                    return parseInt(this.json[information.fieldName] || 0);


            }

            // Non-numeric scalar types (Select, Text, Module, ...) get no type-specific default
            // above, so a blank value must default to '' the same way numeric types default to
            // 0 -- otherwise a formula comparing it directly against '' (e.g. `field('Terms') != ''`)
            // sees null/undefined instead and misreads "blank" as "has a value" (SS05951).
            const value = this.json[information.fieldName];
            return value == null ? '' : value;
        }
    }

    set(displayName, value) {
        let information = this.schema.find(x => x.displayName == displayName);
        if (information != null) {
            // console.log(`${displayName}->${value}`)
            this.json[information.fieldName] = value;
        }
    }
}

export default FETIASEntity;

